// ダッシュボードはjsのため別処理
// import { IAuth } from '@/class/models/common/auth';
import { ApiResult } from '../common/index';

import API from '../common';
import * as models from '@/class/models/views/dashboard';

export const apiGetDashboard = async (): Promise<ApiResult<models.VDashboard>> => {
  const api = new API();
  const res = await api.get<models.VDashboard>('dashboard/');
  return res;
};


export const apiSetDashboard = async (data: any): Promise<any> => {
  const api = new API();
  const res = await api.post<any, any>('dashboard/', data);
  return res;
};

/*
export const apiPost = async (): Promise<void> => {
  const api = new API();
  const returnData = await api.post<Test, Test>('dashboard', {message: 'aaax'});
  // エラー時処理
  const error = api.isError();
  if (error) {
    // console.log(error);
    // console.log(returnData);
  }
};*/


